import React from 'react';

export default function TeamPattern() {
  return (
    <div className="absolute inset-0 pointer-events-none opacity-[0.03]">
      <svg width="100%" height="100%">
        <defs>
          <pattern 
            id="teamPattern" 
            width="40" 
            height="40" 
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(45)"
          >
            {/* Simple dot pattern */}
            <circle cx="20" cy="20" r="1" fill="#B91C1C" />
            
            {/* Decorative elements */}
            <path
              d="M20 10 L20 30 M10 20 L30 20"
              stroke="#B91C1C"
              strokeWidth="0.5"
              opacity="0.6"
            />
            
            {/* Corner flourishes */}
            <path
              d="M5 5 Q10 5 10 10 M35 5 Q30 5 30 10 M5 35 Q5 30 10 30 M35 35 Q35 30 30 30"
              stroke="#B91C1C"
              strokeWidth="0.5"
              fill="none"
              opacity="0.4"
            />
          </pattern>
        </defs>
        
        <rect width="100%" height="100%" fill="url(#teamPattern)" />
      </svg>
    </div>
  );
}